import { render } from "./NeobuqReportView.vue?vue&type=template&id=448feb59&scoped=true"
import script from "./NeobuqReportView.vue?vue&type=script&lang=js"
export * from "./NeobuqReportView.vue?vue&type=script&lang=js"

import "./NeobuqReportView.vue?vue&type=style&index=0&id=448feb59&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448feb59"]])

export default __exports__